import { Button } from '@/common/ui/button'
import {
	AlertDialog,
	AlertDialogAction,
	AlertDialogCancel,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogTitle,
	AlertDialogTrigger,
} from '@/common/ui/alert-dialog'
import { Trash2 } from 'lucide-react'
import { toast } from 'sonner'
import showErrorToast from '@/common/utils/showErrorToast'
import { useQueryClient } from '@tanstack/react-query'
import useMutationDeleteDynamicPage from '@/modules/client-setting/api/hooks/useMutationDeleteDynamicPage'
import { DynamicPageQueryKeys } from '@/modules/client-setting/keys'

interface DeleteDynamicPageModalProps {
	id: string
}

export default function DeleteDynamicPageModal({
	id,
}: DeleteDynamicPageModalProps) {
	const queryClient = useQueryClient()
	const { mutate: deleteDynamicPage } = useMutationDeleteDynamicPage({
		onSuccess: () => {
			toast.success('ลบ page สำเร็จ')
			queryClient.invalidateQueries({
				queryKey: [DynamicPageQueryKeys.GetDynamicPage],
			})
		},
		onError: (error) => {
			showErrorToast(error)
		},
	})

	const handleDelete = () => {
		deleteDynamicPage({ id })
	}

	return (
		<AlertDialog>
			<AlertDialogTrigger asChild>
				<Button variant="ghost" size="icon">
					<Trash2 className="h-4 w-4 text-destructive" />
				</Button>
			</AlertDialogTrigger>
			<AlertDialogContent>
				<AlertDialogHeader>
					<AlertDialogTitle>ยืนยันการลบข้อมูลหน้าเว็บ</AlertDialogTitle>
					<AlertDialogDescription>
						คุณต้องการลบข้อมูลหน้าเว็บนี้ใช่หรือไม่?
					</AlertDialogDescription>
				</AlertDialogHeader>
				<AlertDialogFooter className="gap-2">
					<AlertDialogCancel>ยกเลิก</AlertDialogCancel>
					<AlertDialogAction
						onClick={handleDelete}
						className="bg-destructive hover:bg-destructive/90"
					>
						ยืนยัน
					</AlertDialogAction>
				</AlertDialogFooter>
			</AlertDialogContent>
		</AlertDialog>
	)
}
